import { useState } from 'react';
import { Input, Toast } from 'antd-mobile';
import API from '@/api/modules/staff';
import wx from 'weixin-js-sdk';
import { processingParameters } from '@/utils';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { useThrottleFn } from 'ahooks';
import Export_A from '@/images/common/export_a.png';
import Export_B from '@/images/common/export_b.png';
import Export_C from '@/images/common/export_c.png';
import './index.scss';

const MyBaseExport = () => {
  const { userId, source } = useParams();
  const [emailValue, setEmail] = useState('');
  const [stage, setStage] = useState(1);

  const handleNext = () => {
    if (!emailValue) return;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // 邮箱正则表达式
    if (emailRegex.test(emailValue)) {
      setStage(2);
    } else {
      Toast.show({
        content: '请正确输入邮箱',
      });
    }
  };

  const { run: handleSubmit } = useThrottleFn(
    async () => {
      const params: any = {
        customerId: userId,
        email: emailValue,
        time: new Date().getTime(),
      };
      params.sign = processingParameters(params);
      await API.exportMemberInfo(params);
      setStage(3);
    },
    {
      wait: 500,
      trailing: false,
    }
  );
  const handleOk = () => {
    console.log(source, 'source');
    switch (source) {
      case 'wx':
        wx.miniProgram.navigateBack();
        break;
      case 'zfb':
        Toast.show({
          content: '请点击左上角返回',
        });

        break;
    }
  };

  return (
    <div className="base_wrap">
      {stage === 1 && (
        <div>
          <div className="header">
            <div>
              <div className="base_title">个人信息导出</div>
              <div className="base_text">
                头像、用户名、真实姓名等个人信息
                <br />
                将整理成文件发送到您的邮箱。
                <br />
                下载有效期为7天，
                <br />
                我们不会存储您的邮箱地址。
              </div>
            </div>
            <img className="export_a" src={Export_A} alt="导出" />
          </div>
          <div className="floot">
            <div className="input-email">
              <Input
                value={emailValue}
                clearable
                style={{
                  '--placeholder-color': '#999999',
                  '--font-size': '14px',
                }}
                placeholder="请输入邮箱地址"
                onChange={(val) => {
                  setEmail(val);
                }}
              />
            </div>
            <div
              className={classNames(
                'floot_btn_next',
                emailValue && 'floot_btn_next_ed'
              )}
              onClick={handleNext}
            >
              下一步
            </div>
          </div>
        </div>
      )}
      {stage === 2 && (
        <div className="item_box">
          <div>
            <img className="export_b" src={Export_B} alt="导出" />
          </div>
          <div className="confirm_text">文件将会发送到以下邮箱</div>
          <div className="confirm_value">{emailValue}</div>
          <div className="floot_confirm">
            <div className="floot_reset" onClick={() => setStage(1)}>
              重新填写
            </div>
            <div className="floot_submit" onClick={handleSubmit}>
              提交
            </div>
          </div>
        </div>
      )}
      {stage === 3 && (
        <div className="item_box">
          <div>
            <img className="export_b" src={Export_C} alt="导出" />
          </div>
          <div className="confirm_text end_t">已提交</div>
          <div className="confirm_value end_b">
            个人信息文件将会在72小时内发送到您的邮箱
            <br />
            {emailValue}
          </div>
          <div className="floot_end">
            <div className="floot_submit" onClick={handleOk}>
              我知道了
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyBaseExport;
